/* eslint-disable sonarjs/cognitive-complexity */
/* eslint-disable jsx-a11y/control-has-associated-label */
import React, { Component } from 'react';
import { connect } from 'react-redux';

import { getUsers } from '../../selectors/admin';
import {
  getActiveModal, checkPermisson, getModalData,
  getPagination,
  getTimezone,
} from '../../selectors/common';
import {
  MODALS, SVG_ICONS, PERMISSIONS,
  ROLE_STATUS,
} from '../../constants';
import SVGComponent from '../../components/SVG/SVGComponent';
import FilterW from '../../components/FilterW';
import { getDateTime } from '../../utils/common';
import UserModals from './UserModals';
import { aSetPagination, aUserEditStatus, aUserList, aUserRemove, aUserResetPass } from '../../reducers';
import { aSetFilters, aSetOpenModal } from '../../reducers/common';

const mapToProps = (state) => ({
  pagination: getPagination(state),
  users: getUsers(state),
  activeModal: getActiveModal(state),
  checkPermisson: (payload) => checkPermisson(state, payload),
  modalData: getModalData(state),
  getTimezone: getTimezone(state),
});

const actionsToProps = (dispatch) => ({
  fetchUserList: (payload) => dispatch(aUserList(payload)),
  setOpenModal: (payload) => dispatch(aSetOpenModal(payload)),
  userResetPass: (payload) => dispatch(aUserResetPass(payload)),
  userRemove: (payload) => dispatch(aUserRemove(payload)),
  userEditStatus: (payload) => dispatch(aUserEditStatus(payload)),
  setFilterData: (payload) => dispatch(aSetFilters(payload)),
  setPagination: (payload) => dispatch(aSetPagination(payload)),
});

/**
 * @class
 * @property {object} props
 * @property {object} props.pagination Pagination data
 * @property {Array} props.users User data
 * @property {string} props.activeModal Active modal
 * @property {boolean} props.checkPermisson Check if user have
 * permission for specific action or view
 * @property {object} props.modalData Modal data
 * @property {Function} props.fetchUserList API action to get users list data
 * @property {Function} props.setOpenModal Open modal
 * @property {Function} props.userResetPass  API action to reset user password
 * @property {Function} props.userRemove  API action to remove user
 * @property {Function} props.userEditStatus  API action to edit user status
 * @property {Function} props.setFilterData Filter users
 * @property {Function} props.setPagination Set pagination data
 */
class UserSettings extends Component {
  constructor(props) {
    super(props);

    /**
     * @member {object}
     * @property {number|null} openUserMenuUserId
     * @property {object|null} operation
     * @property {object} operationUser
     */
    this.state = {
      openUserMenuUserId: null,
      operation: null,
      operationUser: {},
    };

    /**
     * @member {Array}
     * @description Filtering fields settings
     */
    this.filterFields = [
      {
        text: 'Username',
        field: 'filterUsername',
      },
      {
        text: 'Email',
        field: 'filterEmail',
      },
    ];

    /**
     * @member {boolean}
     */
    this.addPermission = props.checkPermisson(PERMISSIONS.ADMIN_USERS_ADD);
    // /**
    //  * @member {boolean}
    //  */
    // this.addRolePermission = props.checkPermisson(PERMISSIONS.ADMIN_ROLES_ADD);
    /**
     * @member {boolean}
     */
    this.enablePermission = props.checkPermisson(PERMISSIONS.ADMIN_USERS_ENABLE);
    /**
     * @member {boolean}
     */
    this.resetPassPermission = props.checkPermisson(PERMISSIONS.ADMIN_USERS_RESET_PASSWORD);
    /**
     * @member {boolean}
     */
    this.editRolesPermission = props.checkPermisson(PERMISSIONS.ADMIN_USERS_ROLES);
    /**
     * @member {boolean}
     */
    this.deletePermission = props.checkPermisson(PERMISSIONS.ADMIN_USERS_DELETE);
    /**
     * @member {boolean}
     */
    this.updateUserPermission = props.checkPermisson(PERMISSIONS.ADMIN_USERS_UPDATE);

    /**
     * @member {boolean}
     */
    this.hasThreeDots = this.enablePermission
      || this.resetPassPermission
      || this.editRolesPermission
      || this.updateUserPermission
      || this.deletePermission;

    /**
     * @member {object}
     * @description Confirmation modal data
     */
    this.confirmationData = {
      REMOVE: {
        heading: 'Remove?',
        title: 'Are you sure you want to remove user: ',
        confirmation: this.userRemove,
      },
      DISABLE: {
        heading: 'Disable?',
        title: 'Are you sure you want to disable user: ',
        confirmation: this.disableUser,
      },
      ENABLE: {
        heading: 'Enable?',
        title: 'Are you sure you want to enable user: ',
        confirmation: this.enableUser,
      },
      RESET: {
        heading: 'Reset password?',
        title: 'Are you sure you want to reset password for user: ',
        confirmation: this.resetPassword,
      },
    };
  }

  /**
   * Handle remove user
   *
   * @function
   * @returns {void}
   */
  userRemove = () => {
    this.props.userRemove({
      userId: this.state.operationUser.userId,
      username: this.state.operationUser.username,
    });
    this.closeModal();
  };

  /**
   * Handle disable user
   *
   * @function
   * @returns {void}
   */
  disableUser = () => {
    this.props.userEditStatus({
      userId: this.state.operationUser.userId,
      status: -1,
    });
    this.closeModal();
  };

  /**
   * Handle enable user
   *
   * @function
   * @returns {void}
   */
  enableUser = () => {
    this.props.userEditStatus({
      userId: this.state.operationUser.userId,
      status: 1,
      username: this.state.operationUser.username,
    });
    this.closeModal();
  };

  /**
   * Handle reset password
   *
   * @function
   * @returns {void}
   */
  resetPassword = () => {
    this.props.userResetPass({
      userId: this.state.operationUser.userId,
      username: this.state.operationUser.username,
      email: this.state.operationUser.email,
    });
    this.closeModal();
  };

  /**
   * Handle user menu click
   *
   * @function
   * @param {number} userId
   * @returns {void}
   */
  handleUserMenuClick = (userId) => {
    if (this.state.openUserMenuUserId === userId) {
      this.setState({ openUserMenuUserId: null });
    } else {
      this.setState({ openUserMenuUserId: userId });
    }
  };

  /**
   * Handle user operation click
   *
   * @function
   * @param {object} operation
   * @param {object} user
   * @returns {void}
   */
  handleUserOperationClick = (operation, user) => {
    this.props.setOpenModal({ modal: MODALS.USER_CONFIRM });
    this.setState({
      operation,
      operationUser: user,
      openUserMenuUserId: null,
    });
  };

  /**
   * Handle edit roles
   *
   * @function
   * @param {object} user
   * @returns {void}
   */
  handleEditRoles = (user) => {
    this.setState({
      operationUser: user,
      openUserMenuUserId: null,
    });
    this.props.setOpenModal({ modal: MODALS.USER_EDIT });
  };

  /**
   * Handle edit user information
   *
   * @function
   * @param {object} user
   * @returns {void}
   */
  handleEditUserInfo = (user) => {
    this.setState({
      operationUser: user,
      openUserMenuUserId: null,
    });
    this.props.setOpenModal({ modal: MODALS.USER_INFO_EDIT });
  };

  /**
   * Close modal
   *
   * @function
   * @returns {void}
   */
  closeModal = () => {
    this.props.setOpenModal({ modal: '' });
  };

  /**
   * Render user row
   *
   * @function
   * @param {object} user
   * @returns {void}
   */
  renderUserRow = (user) => {
    const openClass = user.userId === this.state.openUserMenuUserId ? ' open ' : '';
    return (
      <tr key={`user${user.userId}`} className={`table-style__row ${openClass}`}>
        <td>{user.userId}</td>
        <td>{user.username}</td>
        <td>{user.name}</td>
        <td>{user.email}</td>
        <td>{getDateTime(user.insertionDate, this.props.getTimezone)}</td>
        <td>{user.insertionUser}</td>
        <td>{getDateTime(user.lastLogin, this.props.getTimezone)}</td>
        <td className="text-left">
          {user.roles.map((el) => {
            const key = `user-${user.userId}-role-${el.id}`;
            return (
              <div key={key}>
                {el.name}
                {el.status === ROLE_STATUS.DISABLED && <span className="txt-disable">D</span>}
              </div>
            );
          })}
        </td>
        <td className="text-left">{user.status === 1 ? 'Enabled' : 'Disabled'}</td>
        {this.hasThreeDots ? (
          <td className="table-style__icon">
            <SVGComponent
              onClick={this.handleUserMenuClick.bind(this, user.userId)}
              className="icon-xs"
              src={`${SVG_ICONS.utility}#dots`}
            />
            <div className="table-style__option">
              {user.status === 1
                ? this.enablePermission && (
                  <div
                    className={`table-style__option-item ${openClass ? 'active' : ''}`}
                    onClick={
                      this.handleUserOperationClick.bind(this, this.confirmationData.DISABLE, user)
                    }
                  >
                    Disable
                  </div>
                )
                : this.enablePermission && (
                  <div
                    className={`table-style__option-item ${openClass ? 'active' : ''}`}
                    onClick={
                      this.handleUserOperationClick.bind(this, this.confirmationData.ENABLE, user)
                    }
                  >
                    Enable
                  </div>
                )}
              {this.resetPassPermission && (
                <div
                  className="table-style__option-item"
                  onClick={
                    this.handleUserOperationClick.bind(this, this.confirmationData.RESET, user)
                  }
                >
                  Reset Password
                </div>
              )}
              {this.editRolesPermission && (
                <div
                  className="table-style__option-item"
                  onClick={this.handleEditRoles.bind(this, user)}
                >
                  Edit Roles
                </div>
              )}
              {this.updateUserPermission && (
                <div
                  className="table-style__option-item"
                  onClick={this.handleEditUserInfo.bind(this, user)}
                >
                  Edit User
                </div>
              )}
              {this.deletePermission && (
                <div
                  className="table-style__option-item"
                  onClick={
                    this.handleUserOperationClick.bind(this, this.confirmationData.REMOVE, user)
                  }
                >
                  Remove
                </div>
              )}
            </div>
          </td>
        ) : null}
      </tr>
    );
  };

  /**
   * Render No results message
   *
   * @function
   * @returns {view}
   */
  renderNoResults = () => (
    <tr>
      <td>
        <div className="table-error-msg">
          <span>No Results Found</span>
        </div>
      </td>
    </tr>
  );

  /**
   * Render
   *
   * @returns {view}
   */
  render() {
    return (
      <>
        {this.state.openUserMenuUserId
          && <div className="overlay-mask overlay-mask--open" />}
        <FilterW
          filterFields={this.filterFields}
          info
          setFilterData={this.props.setFilterData}
          search={this.props.fetchUserList}
          initialApiCall
          preventBackFilterFunctionality
          allowEmpty
        >
          {this.addPermission && (
            <button
              type="button"
              className="btn btn-secondary"
              onClick={this.props.setOpenModal.bind(this, { modal: MODALS.USER_ADD })}
              id="addUserBtn_UserSettings"
            >
              Add User
            </button>
          )}
        </FilterW>

        <div className="table-wrapper m-t-30">
          <div className="scroll-fade" />
          <div className={`table-responsive fix-10 ${this.state.openUserMenuUserId ? 'overflow-hidden' : ''}`}>

            <table className="table-style" id="data-table">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Username</th>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Creation Date</th>
                  <th>Created By</th>
                  <th>Last Login Date</th>
                  <th className="text-left">Roles</th>
                  <th className="text-left">Status</th>
                  <th className="menu" />
                </tr>
              </thead>
              <tbody>

                {this.props.users?.length > 0
                  ? this.props.users.map((user) => this.renderUserRow(user))
                  : this.renderNoResults()}
              </tbody>
            </table>
          </div>
        </div>

        <div className={`modal ${this.props.activeModal ? 'modal--open' : ''}`}>
          <UserModals
            setOpenModal={this.props.setOpenModal}
            activeModal={this.props.activeModal}
            operation={this.state.operation}
            operationUser={this.state.operationUser}
            closeModal={this.closeModal}
          />
        </div>

      </>

    );
  }
}

export default connect(mapToProps, actionsToProps)(UserSettings);
